"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.config = {
    serviceUrls: {
        localization: 'services/x/localization/v1/',
        logging: 'services/x/logging/v1/',
        token: 'services/api/player/token'
    },
    paths: {
        mocks: 'mocks/'
    },
    const: {
        LOCALES: ''
    }
};



//////////////////
// WEBPACK FOOTER
// ./src/Config.ts
// module id = 93
// module chunks = 0